export default __webpack_public_path__ + "static/media/premium_card.76b6ed47.png";